import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=1b61505e&scoped=true"
import script from "./HeaderNavigation.vue?vue&type=script&lang=js"
export * from "./HeaderNavigation.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./HeaderNavigation.vue?vue&type=style&index=0&id=1b61505e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./HeaderNavigation.vue?vue&type=style&index=1&id=1b61505e&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1b61505e",
  "273d32b2"
  
)

export default component.exports